import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { categoryProductsApi } from "../../redux/features/home/categoryProductsSlice";
import { Button, CircularProgress, IconButton, Rating } from "@mui/material";
import { FaCartShopping } from "react-icons/fa6";
// import { addProductCartApi } from "../../redux/features/cart/addProductCartSlice";
import { toast } from "react-toastify";
// import Loader from "../../components/Loader";
// import ProductsSkeleton from "../../components/ProductsSkeleton";
import { addProductCartApi } from "./../../app/slices/cart/addProductCartSlice";
import { getSpotGoldApi } from "../../app/slices/spotGold/spotGoldSlice";
import ProductsSkeleton from "./../../components/customTable/ProductsSkeleton";
import "./Home.css";
import { useNavigate } from "react-router-dom";

import { Box } from "@mui/system";
import { Close } from "@mui/icons-material";
import { IoMdStar, IoMdStarOutline } from "react-icons/io";
import { getSpotGoldProductDetailsApi } from "../../app/slices/spotGold/spotGoldProductDetailsSlice";
import ProductImageViewer from "./ProductImageViewer";
// import noImageAvailable from "../../../public/img/No images available.png";
import "./ProductDetail.css";

export default function AllProducts() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  // const categoryProductsSliceLoading = useSelector(
  //   (state) => state.categoryProductsSlice
  // );

  // const categoryProductsSliceResponse = useSelector(
  //   (state) => state.categoryProductsSlice.data.data
  // );

  const handleAddCart = (item) => {
    const product = {
      product_id: item.id,
      name: item.productName,
      img: item.productImage,
      weight: item.weight,
      quantity: 1,
      price: item?.productPrice[0]?.finalProductPrice,
    };

    if (token) {
      dispatch(addProductCartApi(product));
      toast.success("Item added to cart");
      setTimeout(() => {
        navigate("/cart");
      }, 1000);
    } else {
      let cart = JSON.parse(sessionStorage.getItem("cart")) || [];

      // Check if the product is already in the cart
      const productIndex = cart.findIndex((p) => p.product_id === item.id);

      if (productIndex !== -1) {
        // If the product is already in the cart, increase the quantity
        cart[productIndex].quantity += 1;
      } else {
        // If the product is not in the cart, add it
        cart.push(product);
      }

      sessionStorage.setItem("cart", JSON.stringify(cart));
      toast.success("Item added to cart in session");
    }
  };

  const spotGoldSliceResponse = useSelector(
    (state) => state.spotGoldSlice.spotGold.data,
  );
  // console.log("spotGoldSliceResponse: ", spotGoldSliceResponse);
  const spotGoldSliceLoading = useSelector(
    (state) => state.spotGoldSlice.loading,
  );

  useEffect(() => {
    dispatch(getSpotGoldApi());
  }, []);

  const [showDetails, setShowDetails] = useState(false);
  const sliceResponse = useSelector(
    (state) => state.spotGoldProductDetailsSlice.spotGoldProductDetails.data,
  );
  // console.log("sliceResponse: product details api //", sliceResponse);
  const [selectedImage, setSelectedImage] = useState("");
  const [productImages, setProductImages] = useState([]);
  // console.log("productImages: ", productImages);

  useEffect(() => {
    if (sliceResponse) {
      const mainImage = sliceResponse?.productImage
        ? [{ URL: sliceResponse.productImage }]
        : [];

      const otherImages = sliceResponse?.productImages || [];

      const merged = [...mainImage, ...otherImages].filter(
        (value, index, self) =>
          self.findIndex((v) => v.URL === value.URL) === index,
      );

      setProductImages(merged);

      if (merged.length > 0) {
        setSelectedImage(merged[0].URL);
      }
    }
  }, [sliceResponse]);
  return (
    <>
      <>
        <Box
          sx={{
            display: showDetails ? "flex" : "none",
            flexDirection: "column",
            // justifyContent: "flex-start",
            // gap: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              // padding: "10px",
              mb: -2,
              mt: -2,
            }}
          >
            <IconButton sx={{ float: "right" }}>
              <Close size="small" onClick={() => setShowDetails(false)} />
            </IconButton>
          </Box>
          <Box>
            <main
              className="universal_container"
              style={{ margin: "2rem auto 4rem auto" }}
            >
              <section style={{ marginBottom: "4rem" }}>
                <div className="product_detail_main">
                  <div>
                    {selectedImage ? (
                      <>
                        <div
                          style={{
                            border: "1px solid lightgray",
                            padding: "1rem",
                            borderRadius: "10px",
                          }}
                        >
                          <ProductImageViewer images={productImages} />
                        </div>
                      </>
                    ) : (
                      <CircularProgress />
                      // <Loader />
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        // marginTop: "10px",
                      }}
                    ></div>
                  </div>
                  <div
                    style={{
                      border: "1px solid lightgray",
                      padding: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h3>{sliceResponse?.productName}</h3>
                    <div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <IoMdStar color="#EDBF00" />
                        <IoMdStar color="#EDBF00" />
                        <IoMdStar color="#EDBF00" />
                        <IoMdStar color="#EDBF00" />
                        <IoMdStarOutline color="#EDBF00" />
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "baseline",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: "600",
                        }}
                      >
                        ₹{sliceResponse?.productPrice[0]?.finalProductPrice}
                      </div>
                    </div>
                    <div
                      style={{ display: "flex", gap: "1rem", fontSize: "14px" }}
                    >
                      <div style={{ fontWeight: "600" }}>
                        <div>Weight</div>
                        <div>SKU</div>
                        <div>Purity</div>
                      </div>
                      <div>
                        <div>:</div>
                        <div>:</div>
                        <div>:</div>
                      </div>
                      <div>
                        <div>{sliceResponse?.weight || "null"}gm</div>
                        <div>{sliceResponse?.sku || "null"}</div>
                        <div>
                          {sliceResponse?.subCategory?.category
                            ?.conversionFactor || "null"}
                        </div>
                      </div>
                    </div>

                    {sliceResponse?.metaDescription && (
                      <div style={{ marginTop: "1rem" }}>
                        <div style={{ fontWeight: "600", fontSize: "1.2rem" }}>
                          Description
                        </div>
                        <p>{sliceResponse?.metaDescription}</p>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        marginTop: "2rem",
                      }}
                    >
                      {/* <Button
                      label="Buy Now"
                      variant="outlined"
                      size="large"
                      // endIcon={<BsFillLightningChargeFill />}
                      // onClick={handleBuyNow}
                    >Buy Now</Button> */}
                      <Button
                        label="Add to cart"
                        variant="outlined"
                        size="large"
                        // color="#4a2a7d"
                        sx={{
                          color: "#472878",
                          borderColor: "#472878",
                        }}
                        // endIcon={<FaShoppingCart />}
                        onClick={() => handleAddCart(sliceResponse)}
                      >
                        Add to cart
                      </Button>
                    </div>
                  </div>
                </div>
              </section>
            </main>
          </Box>
        </Box>
      </>

      {/*  */}

      <div className="gold-products-container">
        {spotGoldSliceLoading == true ? (
          <>
            {[...Array(10)].map((_, index) => (
              <ProductsSkeleton key={index} />
            ))}
          </>
        ) : (
          spotGoldSliceResponse?.data?.map((item, index) => (
            <div
              key={index}
              style={{
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                borderRadius: "7px",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              {/* <a href="#"> */}
              {/* <a href={`${item.id}`} target="_blank" rel="noopener noreferrer"> */}
              <div
                className="image-container"
                style={{
                  width: "100%",
                  height: "150px",
                  overflow: "hidden",
                }}
                onClick={() => {
                  dispatch(getSpotGoldProductDetailsApi(item.id));
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth", // for smooth scrolling
                  });
                  setShowDetails(true);
                }}
              >
                <img
                  src={
                    item.productImage !== "0"
                      ? item.productImage
                      : "/img/No images available.png"
                  }
                  className="zoom-image"
                  width="100%"
                  height={100}
                  alt="productImg"
                />
              </div>
              {/* </a> */}
              <div
                style={{
                  // display: "flex",
                  padding: "10px",
                  // alignItems: "center",
                  // justifyContent: "center",
                }}
              >
                <h5 style={{ textAlign: "center" }}>
                  {item.productName.length > 25
                    ? `${item.productName.substring(0, 20)}...`
                    : item.productName}
                </h5>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <div>
                    <Rating
                      name="size-small"
                      // name="read-only"
                      size="small"
                      defaultValue={4}
                      readOnly
                      color="#EDBF00" 
                    />
                     
                  </div> */}
                  <div>
                    <div style={{ display: "flex", gap: "5px" }}>
                      <IoMdStar color="#EDBF00" />
                      <IoMdStar color="#EDBF00" />
                      <IoMdStar color="#EDBF00" />
                      <IoMdStar color="#EDBF00" />
                      <IoMdStarOutline color="#EDBF00" />
                    </div>
                  </div>
                  {/* <span>322</span> */}
                </div>

                <div
                  style={{
                    display: "flex",
                    // gap: "10px",
                    // alignItems: "baseline",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ fontSize: "15px", fontWeight: "bold" }}>
                    ₹{item.productPrice[0].finalProductPrice}
                  </div>
                </div>
                <Button
                  variant="outlined"
                  // variant="contained"
                  fullWidth
                  onClick={() => handleAddCart(item)}
                  // endIcon={<FaCartShopping />}
                  sx={{
                    color: "#472878",
                    borderColor: "#472878",
                  }}
                >
                  Add to Cart
                </Button>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}
